import type { ReactNode } from "react";
import { Button } from "@mui/material";
import ModalHeader from "src/components/general/Modal/components/ModalHeader/ModalHeader";
import Modal from "src/components/general/Modal/Modal";
import { CONTENT_CLASSNAME } from "./SystemSettingsIntegrationDialog.constants";

export interface SystemSettingsIntegrationDialogProps {
  type: string;
  dialogTitle: string;
  /** -1 add, >= 0 edit. Kept through the exit fade so the title stays put. */
  index: number;
  isOpen: boolean;
  canSave: boolean;
  onClose: () => void;
  onSave: () => void;
  /** Shows a "Test connection" button when set. */
  onTest?: () => void;
  isTesting?: boolean;
  onExited?: () => void;
  children: ReactNode;
}

export default function SystemSettingsIntegrationDialog({
  type,
  dialogTitle,
  index,
  isOpen,
  canSave,
  onClose,
  onSave,
  onTest,
  isTesting,
  onExited,
  children,
}: SystemSettingsIntegrationDialogProps) {
  const adding = index < 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onExited={onExited}
      size="fit"
      testId={`integration-dialog-${type}`}
    >
      <ModalHeader
        title={`${adding ? "Add" : "Edit"} ${dialogTitle}`}
        onClose={onClose}
      />

      <div className={CONTENT_CLASSNAME}>{children}</div>

      <footer className="flex justify-end gap-2 px-6 pb-6">
        {onTest && (
          <Button
            className="mr-auto"
            onClick={onTest}
            disabled={!canSave || isTesting}
            data-test-id={`integration-test-${type}`}
          >
            {isTesting ? "Testing…" : "Test connection"}
          </Button>
        )}
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!canSave}
          data-test-id={`integration-submit-${type}`}
        >
          {adding ? `Add ${dialogTitle}` : "Save"}
        </Button>
      </footer>
    </Modal>
  );
}
